import React from 'react';
import axios from 'axios';
import { Cookies } from 'react-cookie';
import queryString from 'query-string';
import { instance } from './common';



function kakaoLogout(Kakao){
    Kakao.API.request({
        url : "/v1/user/unlink",
        success : function( res ) {
            console.log('res : ', res.id);
            if(res.id){
                alert("정상적으로 로그아웃 되었습니다.");
                window.location.replace("/");
            }
        },
    });
}

function naverLogout(){
    const cookies = new Cookies();
    const naver_token = cookies.get('naver_token');
    let obj = {
        token : naver_token
    }
    const fetchData = async () => {
        instance.post('/users/delete-token',obj).then(function(res){
            alert("정상적으로 로그아웃 되었습니다.");
            window.location.replace("/");
        });
    
    };

    fetchData();
}




function Logout({location}){
    const query = queryString.parse(location.search);
    let kind = query.kind;
    const {Kakao} = window;
    console.log('Kakao : ', Kakao.Auth);
    const cookies = new Cookies();
   
    window.sessionStorage.clear();
    cookies.remove('isAutoLogin');
    
    if(kind == 'kakao'){
        kakaoLogout(Kakao);
    }else if(kind == 'google'){
        alert("정상적으로 로그아웃 되었습니다.");
        window.location.replace("/");
    }else if(kind == 'naver'){
        naverLogout();
    }else{
        alert("정상적으로 로그아웃 되었습니다.");
        window.location.replace("/");
    }
    
    

    return (
        <div></div>
    )
}

export default Logout;